import { skipToken } from "@reduxjs/toolkit/query";

import { useGetSanctionsQuery } from "@/redux/service";
import { isPaginatedResponse } from "@/redux/typeGuards";
import { SANCTION_KINDS } from "@/domains/moderation/constants";

export const useActiveBan = (userId: number | null) => {
  const { data } = useGetSanctionsQuery(
    userId === null
      ? skipToken
      : { user: userId, isActive: true, pagination: "off" },
  );
  const sanctions = data
    ? isPaginatedResponse(data)
      ? data.results
      : data
    : [];
  return (
    sanctions.find(
      (sanction) =>
        sanction.kind === SANCTION_KINDS.BAN &&
        sanction.isActive &&
        (sanction.endsAt === null ||
          sanction.endsAt > new Date().toISOString()),
    ) ?? null
  );
};
